
export function Admin() {
    return (
        <div>Hola</div>
    )
}